/**
 * Workflows, the template follow-ups: a booking card or lead form that closes after a while ("Not booked within 30
 * min") and a wait that lasts until the office opens. Merged into `engage.workflows` (summaries, exits and fields).
 */
export const workflowsFollowups = {
  summaries: {
    waitUntilOpen: "Wait until the office opens",
  },
  exits: {
    notSubmitted: "Details not sent",
    notBooked_minutes_one: "Not booked within {{count}} min",
    notBooked_minutes_other: "Not booked within {{count}} min",
    notBooked_hours_one: "Not booked within {{count}} hour",
    notBooked_hours_other: "Not booked within {{count}} hours",
    notBooked_days_one: "Not booked within {{count}} day",
    notBooked_days_other: "Not booked within {{count}} days",
    notSubmitted_minutes_one: "Details not sent within {{count}} min",
    notSubmitted_minutes_other: "Details not sent within {{count}} min",
    notSubmitted_hours_one: "Details not sent within {{count}} hour",
    notSubmitted_hours_other: "Details not sent within {{count}} hours",
    notSubmitted_days_one: "Details not sent within {{count}} day",
    notSubmitted_days_other: "Details not sent within {{count}} days",
  },
  fields: {
    waitMode: "Wait",
    waitModes: { for: "For a set time", office: "Until the office opens" },
    waitOfficeHint: "Waits for the agent's next opening (its office hours, in your workspace time zone) and is skipped when the office is already open. Your plan allows waits of up to {{value}} {{unit}}: a longer closure ends the wait at that limit.",
    bookingTimeout: "Close the booking card after",
    bookingTimeoutHint: "Without a booking by then, the card is closed for the visitor and the run takes the Not booked exit.",
    leadTimeout: "Close the form after",
    leadTimeoutHint: "If the details are not sent by then, the form is closed for the visitor and the run takes the Details not sent exit.",
  },
} as const;
